import { render, staticRenderFns } from "./LinkedAccountsDialog.vue?vue&type=template&id=1a7d48f2"
import script from "./LinkedAccountsDialog.vue?vue&type=script&lang=js"
export * from "./LinkedAccountsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports